import{getDefaultExportFromCjs as r}from"./_commonjsHelpers.js";import{__require as t}from"../node_modules/.pnpm/interactjs@1.10.27/node_modules/interactjs/dist/interact.min.js";var e=t();const i=r(e);export{i as default};
